import ReactDOM from "react-dom/client"
import Home from "./views/Home/Home"
import "./index.css"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <>
   
    <Home />

    </>
)